// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import Image from '@tcp/core/src/components/common/atoms/Image';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import internalEndpoints from '@tcp/core/src/components/features/account/common/internalEndpoints';
import { routerPush, getIconPath } from '@tcp/core/src/utils';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import HeaderLabels, { GLOBAL_LABELS, ACCOUNT_LABELS } from '../../labels/HeaderNew.labels';
import { brand } from '../../../../../../constants/constants';

const onLinkRedirect = ({
  e,
  link,
  path,
  userName,
  isWishList,
  isStoreLocator,
  isTrackOrder,
  closeDrawer,
  isGuestFavEnabled,
}) => {
  e.preventDefault();
  closeDrawer();
  if (isWishList) {
    if (userName || (isGuestFavEnabled && !userName)) {
      routerPush(link, path);
    } else {
      const { pathname = 'referrer' } = (window && window.location) || {};
      routerPush(`/home?target=login&successtarget=${pathname}`, '/home/login');
    }
  }
  if (isStoreLocator || isTrackOrder) {
    routerPush(link, path);
  }
};

const NewHamBurgerMenu = ({ brandId, userName, closeDrawer, isGuestFavEnabled }) => {
  const globalLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, HeaderLabels);
  const accountLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_LABELS, HeaderLabels);

  const findOrderText = renderLabel(
    globalLabels?.trackOrder?.lbl_findOrder_orders,
    'lbl_findOrder_orders'
  );
  const myStoreText = renderLabel(
    accountLabels?.accountOverview?.lbl_overview_myStore,
    'lbl_overview_myStore'
  );
  const myFavoriteText = renderLabel(
    accountLabels?.accountOverview?.lbl_overview_headerMyFavorite,
    'lbl_overview_headerMyFavorite'
  );
  const iconCls = 'hamburger-icon';
  return (
    <>
      {
        <BodyCopy
          id="sideNavUserInfo"
          component="div"
          className={`account-hamburger-section account-main-section-${brandId}`}
          fontFamily="secondary"
          fontSize="fs14"
        >
          <Anchor
            to=""
            id="wishlistIcon"
            className="hamburger-item"
            onClick={(e) =>
              onLinkRedirect({
                e,
                link: internalEndpoints.favorites.link,
                path: internalEndpoints.favorites.path,
                userName,
                isWishList: true,
                closeDrawer,
                isGuestFavEnabled,
              })
            }
            fontSizeVariation="large"
            anchorVariation="primary"
            noLink
          >
            <Image src={getIconPath('hamburgerFav')} alt={'hamburgerFav'} className={iconCls} />
            <p className="icon-text">{myFavoriteText.toLowerCase()}</p>
          </Anchor>
          <Anchor
            to=""
            id="trackOrderIcon"
            className="hamburger-item"
            onClick={(e) =>
              onLinkRedirect({
                e,
                link: internalEndpoints.trackOrder.link,
                path: internalEndpoints.trackOrder.path,
                isTrackOrder: true,
                closeDrawer,
              })
            }
            fontSizeVariation="large"
            anchorVariation="primary"
            noLink
          >
            <Image src={getIconPath('hamburgerOrders')} alt={'orders'} className={iconCls} />
            <p className="icon-text">{findOrderText.toLowerCase()}</p>
          </Anchor>
          {brandId !== brand.SNJ && brandId !== brand.PJP && (
            <Anchor
              to=""
              id="storeLocatorIcon"
              className="hamburger-item"
              onClick={(e) =>
                onLinkRedirect({
                  e,
                  link: internalEndpoints.storeLocator.link,
                  path: internalEndpoints.storeLocator.path,
                  isStoreLocator: true,
                  closeDrawer,
                })
              }
              fontSizeVariation="large"
              anchorVariation="primary"
              noLink
            >
              <Image
                src={getIconPath('hamburgerMarkerIcon')}
                alt={'hamburgerMarkerIcon'}
                className={iconCls}
              />
              <p className="icon-text">{myStoreText.toLowerCase()}</p>
            </Anchor>
          )}
        </BodyCopy>
      }
    </>
  );
};

NewHamBurgerMenu.propTypes = {
  brandId: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  closeDrawer: PropTypes.func.isRequired,
  isGuestFavEnabled: PropTypes.bool,
};
NewHamBurgerMenu.defaultProps = {
  isGuestFavEnabled: false,
};
export default NewHamBurgerMenu;
